import React from 'react';
import styled, { css } from 'styled-components';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import useTranslation from 'hooks/use-translation';

import { dispensaryHoursForDay } from 'shared/helpers/dispensaries';

import { paragraph, smallCapsSubtext } from 'components/core/typography';

const days = [
  { fullName: `Sunday`, abbrv: `Sun` },
  { fullName: `Monday`, abbrv: `Mon` },
  { fullName: `Tuesday`, abbrv: `Tues` },
  { fullName: `Wednesday`, abbrv: `Wed` },
  { fullName: `Thursday`, abbrv: `Thurs` },
  { fullName: `Friday`, abbrv: `Fri` },
  { fullName: `Saturday`, abbrv: `Sat` },
];

export default function OrderingHours(props) {
  const {
    dispensary: { effectiveHours, offerDelivery, offerAnyPickupService, status },
  } = props;
  const { t } = useTranslation();
  const isDesktopMenuSize = useMediaQuery((theme) => theme.breakpoints.up(`md`));
  const closedText = t('storeInfo.closed', 'Closed');

  return (
    <OrderingHoursTable cellSpacing={0}>
      <TableRow>
        <HeaderCell firstColumn>{t('common.day', 'Day')}</HeaderCell>
        {offerAnyPickupService && <HeaderCell>{t('common.pickup', 'Pickup')}</HeaderCell>}
        {offerDelivery && <HeaderCell>{t('common.delivery', 'Delivery')}</HeaderCell>}
      </TableRow>
      {days.map((day) => (
        <TableRow key={day.abbrv}>
          <BodyCell firstColumn>{isDesktopMenuSize ? `${day.fullName}:` : day.abbrv}</BodyCell>
          {offerAnyPickupService && (
            <BodyCell>
              {status !== 'open' ? closedText : dispensaryHoursForDay(effectiveHours.pickupHours[day.fullName])}
            </BodyCell>
          )}
          {offerDelivery && (
            <BodyCell>
              {status !== 'open' ? closedText : dispensaryHoursForDay(effectiveHours.deliveryHours[day.fullName])}
            </BodyCell>
          )}
        </TableRow>
      ))}
    </OrderingHoursTable>
  );
}

const OrderingHoursTable = styled.table`
  table-layout: fixed;
`;

const TableRow = styled.tr`
  white-space: nowrap;
`;

const cellStyles = css`
  max-width: 120px;
  width: 100%;
  display: inline-flex;
  align-items: center;
  padding: 8px 0;

  ${({ firstColumn }) =>
    firstColumn
      ? `
    font-weight: bold;
    max-width: 80px;

    @media (min-width: 960px) {
      max-width: 125px;
    }
  `
      : `
    max-width: 120px;

    @media (min-width: 960px) {
      max-width: 140px;
    }
  `}
`;

const HeaderCell = styled.th`
  ${cellStyles}
  ${smallCapsSubtext}
  
  padding-top: 0;
  text-align: left;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.grey[60]};
`;

const BodyCell = styled.td`
  ${cellStyles}
  ${paragraph}
`;
